import { WCCVideoPickerVMConfig } from 'components/wccVideoPicker/wccVideoPicker';
import WCCVideo from 'models/attachments/video';
import overlayManager from './overlay';

components.preload('wcc-video-picker');

export interface WCCVideoPickerManagerConfig {
    key?: string
}

export default class WCCVideoPickerManager {
    constructor(private config: WCCVideoPickerManagerConfig) { }

    pick() {
        return new Promise<WCCVideo | undefined>(resolve => {
            overlayManager.toOverlay(`<wcc-video-picker params="model: $data"/>`, {
                lock: true,
                buttons: ['close'],

                data: stage => {
                    return <WCCVideoPickerVMConfig>{
                        key: this.config.key,

                        onUploaded: video => {
                            resolve(video);
                            stage.close();
                        }
                    }
                },

                onClose: () => resolve(undefined)
            });            
        });
    }
}